import { createSlice } from '@reduxjs/toolkit';

import { getIndiaAwaitingBoxes, receivedIndiaBoxes, inwardIndiaBoxes } from '../../apis';

export const IndiaInwardPlatform = createSlice({

    name: 'indiaInwardPlatform',
    initialState: {
        loading: false,
        error: '',
        receivedIndiaBoxesData: [],
        inwardIndiaSuccess: false,
        getIndiaAwaitingBoxesData: []
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearIndiaInwardSuccess: (state, action) => {
            return {
                ...state,
                inwardIndiaSuccess: action.payload
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getIndiaAwaitingBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getIndiaAwaitingBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.getIndiaAwaitingBoxesData = action.payload.data
        })
        builder.addCase(getIndiaAwaitingBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(receivedIndiaBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(receivedIndiaBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.receivedIndiaBoxesData = action.payload.data
        })
        builder.addCase(receivedIndiaBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(inwardIndiaBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(inwardIndiaBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.inwardIndiaSuccess = true
        })
        builder.addCase(inwardIndiaBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const { clearError, clearIndiaInwardSuccess } = IndiaInwardPlatform.actions

export default IndiaInwardPlatform.reducer